import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AlertDialogComponent } from './dialogs/alert-dialog/alert-dialog.component';
import { AttachmentDialogComponent } from './dialogs/attachment-dialog/attachment-dialog.component';
import { AttachmentDialogService } from './dialogs/attachment-dialog/attachment-dialog.service';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { RxButtonModule } from '@nrwl/rx-button';
import { RxDirectivesModule } from '@nrwl/rx-directives';
import { RxFormBuilderModule } from '@nrwl/rx-form-builder';
import { RxFormPresenterComponent } from './rx-form-presenter.component';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxSignatureModule } from '@nrwl/rx-signature';
import { RxSpinnerModule } from '@nrwl/rx-spinner';
import { RxUploadModule } from '@nrwl/rx-upload';
import { SignDialogComponent } from './dialogs/sign-dialog/sign-dialog.component';
import { SignDialogService } from './dialogs/sign-dialog/sign-dialog.service';
import { HelpersModule } from '../helpers/helpers.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RxFormBuilderModule,
    RxIconModule,
    PdfViewerModule,
    RxButtonModule,
    RxUploadModule,
    RxSignatureModule,
    RxDirectivesModule,
    RxSpinnerModule,
    HelpersModule,
    RxFormPresenterComponent,
    AttachmentDialogComponent,
    SignDialogComponent,
    AlertDialogComponent,
  ],
  exports: [
    RxFormPresenterComponent,
    AttachmentDialogComponent,
    SignDialogComponent,
    AlertDialogComponent,
    PdfViewerModule,
    AttachmentDialogComponent,
    SignDialogComponent,
    AlertDialogComponent,
  ],
  providers: [AttachmentDialogService, SignDialogService],
})
export class RxFormPresenterModule {}
